import { defineMessages } from 'react-intl';

import { LANGUAGES } from '@savgroup-front-common/constants';

export default defineMessages({
  [LANGUAGES.EN]: {
    id: 'components.myaccount.layout.header.languageChooser.en',
    defaultMessage: 'English',
  },
  [LANGUAGES.FR]: {
    id: 'components.myaccount.layout.header.languageChooser.fr',
    defaultMessage: 'Français',
  },
  [LANGUAGES.ES]: {
    id: 'components.myaccount.layout.header.languageChooser.es',
    defaultMessage: 'Español',
  },
  [LANGUAGES.DE]: {
    id: 'components.myaccount.layout.header.languageChooser.de',
    defaultMessage: 'Deutsch',
  },
  [LANGUAGES.IT]: {
    id: 'components.myaccount.layout.header.languageChooser.it',
    defaultMessage: 'Italiano',
  },
  [LANGUAGES.PT]: {
    id: 'components.myaccount.layout.header.languageChooser.pt',
    defaultMessage: 'Português',
  },
  [LANGUAGES.NL]: {
    id: 'components.myaccount.layout.header.languageChooser.nl',
    defaultMessage: 'Nederlands',
  },
  [LANGUAGES.PL]: {
    id: 'components.myaccount.layout.header.languageChooser.pl',
    defaultMessage: 'Polski',
  },
  [LANGUAGES.SV]: {
    id: 'components.myaccount.layout.header.languageChooser.sv',
    defaultMessage: 'Svenska',
  },
  [LANGUAGES.FI]: {
    id: 'components.myaccount.layout.header.languageChooser.fi',
    defaultMessage: 'Suomi',
  },
  [LANGUAGES.NO]: {
    id: 'components.myaccount.layout.header.languageChooser.no',
    defaultMessage: 'Norsk',
  },
  [LANGUAGES.DA]: {
    id: 'components.myaccount.layout.header.languageChooser.da',
    defaultMessage: 'Dansk',
  },
  [LANGUAGES.CS]: {
    id: 'components.myaccount.layout.header.languageChooser.cs',
    defaultMessage: 'Čeština',
  },
  [LANGUAGES.HU]: {
    id: 'components.myaccount.layout.header.languageChooser.hu',
    defaultMessage: 'Magyar',
  },
  [LANGUAGES.RO]: {
    id: 'components.myaccount.layout.header.languageChooser.ro',
    defaultMessage: 'Română',
  },
  [LANGUAGES.EL]: {
    id: 'components.myaccount.layout.header.languageChooser.el',
    defaultMessage: 'Ελληνικά',
  },
  [LANGUAGES.TR]: {
    id: 'components.myaccount.layout.header.languageChooser.tr',
    defaultMessage: 'Türkçe',
  },
  [LANGUAGES.BG]: {
    id: 'components.myaccount.layout.header.languageChooser.bg',
    defaultMessage: 'Български',
  },
  title: {
    id: 'components.myaccount.layout.header.languageChooser.title',
    defaultMessage: 'Change language',
  },
  chooseLanguageAriaLabel: {
    id: 'ariaLabel.chooseLanguageAriaLabel',
    defaultMessage: 'Choose language',
  },
});
